import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import IconChevronLeftSmall from "@amzn/stencil-react-icons/icons/icon-chevron-left-small";
type ContextualBackButtonProps = {
  buttonText: string;
  buttonIcon?: JSX.Element;
  buttonOnClickHandler: () => void;
  dataTestId?: string;
};

export const BackButton = ({
  buttonText,
  buttonIcon = <IconChevronLeftSmall />,
  buttonOnClickHandler,
  dataTestId,
}: ContextualBackButtonProps): JSX.Element => {
  return (
    <Button
      onClick={() => buttonOnClickHandler()}
      variant={ButtonVariant.Tertiary}
      dataTestId={dataTestId}
      icon={buttonIcon}
    >
      {buttonText}
    </Button>
  );
};
